import React from "react";
import { useNavigate } from "react-router-dom";

import * as styles from "./EntityFormPage.module.css";

function EntityFormPage({
  title,
  backTo,
  onBack,
  children,
  footer,
  afterFooter,
}) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) return onBack();
    if (backTo) return navigate(backTo);
    navigate(-1);
  };

  return (
    <div className={styles.formPage}>
      <div className={styles.formPageHeader}>
        <div className={styles.titleWrapper}>
          <button
            type="button"
            className={styles.backBtn}
            onClick={handleBack}
            aria-label="Back"
          >
            <i className="pi pi-arrow-left" />
          </button>
          <h2>{title}</h2>
        </div>
      </div>
      <div className={styles.formCard}>
        {children}
        {footer && <div className={styles.formFooter}>{footer}</div>}
        {afterFooter && <div className={styles.afterFooter}>{afterFooter}</div>}
      </div>
    </div>
  );
}

export default EntityFormPage;
